import React from 'react';
import { useNavigate } from 'react-router-dom';

import { loadStripe } from '@stripe/stripe-js';
import { postData } from '../lib/utils';
 
//const stripePromise = loadStripe('pk_test_51RQ4tn2fnTkCyqFhDwtMg7r3I1JFBU9nw6S8RBbNodXQOG9AIT8yExCByTEE4FLADwqEfCNuRc5v37qo5z1tMqMt00jXcKzByj');

const Pricing = () => {
  
  const navigate = useNavigate();
  const handlePlanClick = async(planName) => { 

    navigate("/signup");
  };
 

  const plans = [
    {
      name: 'On Demand ',
      title: '(No Monthly Fees)',
      price:' ',
       
      features: [['5 Credits 25GB', '$35'], ['10 Credits 50GB', '$65'], ['20 Credits 100GB', '$120'], ['100 Credits 500GB', '$500']]

    },
    {
      name: 'Pro',
      price: '$79/mo',
      features: ['Deliver Video + Photo', '1TB of Upload per year', '2 Years of Gallery Access + Downloads', 'White-labeling Add-on included'],
    },
    {
      name: 'Unlimited',
      price: '$165/mo',
      features: ['Deliver Video + Photo', '5TB of Upload per year', '2 Years of Gallery Access + Downloads', 'White-labeling Add-on included'],
    },
  ];

  return (
    <div className="bg-gray-900 text-white min-h-screen py-12 px-4">
    <h2 className="text-3xl font-bold text-center mb-8">Our Pricing Plans</h2>
    <div className="grid gap-8 md:grid-cols-3 max-w-6xl mx-auto">
      {plans.map((plan) => (
        <div
          key={plan.name}
          onClick={() => handlePlanClick(plan.name)}
          className="cursor-pointer border border-gray-700 rounded-xl p-6 
            hover:scale-105 active:scale-110 transition-transform duration-300 
            hover:shadow-lg hover:bg-gray-800"
        >
          <h3 className="text-2xl font-semibold text-yellow-400">{plan.name}</h3>
          {plan?.title && <h3 className="text-2xl font-semibold  text-yellow-400">{plan.title}</h3>}
          
          {plan?.price && <p className="text-3xl font-bold mb-4">{plan.price}</p>}
          <ul className="mb-6 space-y-2 text-lg font-bold">
            {plan.features.map((feature, idx) =>
              Array.isArray(feature) ? (
                <li key={idx} className="text-gray-300 flex justify-evenly">
                  <span>• {feature[0]}</span>
                  <span>{feature[1]}</span>
                </li>
              ) : (
                <li key={idx} className="text-gray-300">• {feature}</li>
              )
            )}
          </ul>

          <button
            onClick={(e) => {
              e.stopPropagation(); // prevent bubbling
              handlePlanClick(plan.name);
            }}
            className="mt-auto bg-gray-800 hover:bg-gray-700 text-white px-4 py-2 rounded w-full"
          >
            Choose {plan.name}
          </button>
        </div>
      ))}
    </div>
  </div>
  );
};

export default Pricing;
